module.exports = __webpack_public_path__ + "img/card-list.83940823.svg";